import styled from 'styled-components';

const PlainLink = styled.a`
  color: ${props => props.theme.colors.common.link};

  &:hover,
  &:active {
    color: ${props => props.theme.colors.common.linkActive};
    text-decoration: underline;
  }
`;

export default PlainLink;
